import {
  Component,
  inject,
  input,
  OnInit,
  output,
  viewChild,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { required } from '@dgacontrol-frontend/shared/util/forms';
import { RippleModule } from 'primeng/ripple';

import { PanelModule } from 'primeng/panel';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { CustomProgressSpinnerComponent } from '@dgacontrol-frontend/shared/ui/spinner';
import { LayoutService } from '@dgacontrol-frontend/sakai-ng';

@Component({
  selector: 'lib-auth-ui-frm-login',
  standalone: true,
  imports: [
    PanelModule,
    ReactiveFormsModule,
    PasswordModule,
    FormsModule,
    CheckboxModule,
    ButtonModule,
    InputTextModule,
    RippleModule,
    ToastModule,
    MessageModule,
    CustomProgressSpinnerComponent,
  ],
  providers: [LayoutService],
  templateUrl: './frm-login.component.html',
  styleUrl: './frm-login.component.scss',
})
export class FrmLoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({});
  submitted = false;
  loading = false;
  password = '';
  error = '';
  // DGA data transmission system to MEE per resolution 1238
  readonly tittle1 = input('Sistemas de transmisión de datos al MEE');
  readonly tittle2 = input('de la DGA según resolución 1238');
  readonly showForgotPassword = input(false);
  readonly rememberMe = input(false);
  readonly customProgressSpinner = viewChild.required<CustomProgressSpinnerComponent>('vcCustomProgressSpinnerComponent');
  readonly evtLoginSubmit = output<{ username: string; password: string }>();
  formBuilder: FormBuilder = inject(FormBuilder);
  layoutService: LayoutService = inject(LayoutService);

  ngOnInit() {
    this.form();
  }

  form() {
    this.loginForm = this.formBuilder.group({
      username: ['', required],
      password: ['', required],
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.evtLoginSubmit.emit(this.loginForm.value as { username: string; password: string });
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}
